/**
 * Daily Limits Configuration for Frontend
 * 可以通过 environment variables 配置日常限制
 */

// Helper function to get env variable or default
const getEnvInt = (key, defaultValue) => {
  const value = process.env[`REACT_APP_${key}`];
  if (!value) return defaultValue;
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? defaultValue : parsed;
};

const DAILY_LIMITS_CONFIG = {
  // Daily post limit per user
  POST_PER_USER: getEnvInt("DAILY_LIMIT_POST_PER_USER", 20),

  // Daily AI image limit per user
  AI_IMAGE_PER_USER: getEnvInt("DAILY_LIMIT_AI_IMAGE_PER_USER", 2),

  // Daily AI image limit for entire system
  AI_IMAGE_GLOBAL: getEnvInt("DAILY_LIMIT_AI_IMAGE_GLOBAL", 200),

  // Reset hour (0-23, UTC+7)
  RESET_HOUR: getEnvInt("DAILY_LIMIT_RESET_HOUR", 0),

  // Reset minute (0-59)
  RESET_MINUTE: getEnvInt("DAILY_LIMIT_RESET_MINUTE", 1),

  // Max auto post hours (per-user limit for auto-post configurations)
  MAX_AUTO_POST_HOURS: getEnvInt("MAX_AUTO_POST_HOURS", 5),
};

// Log configuration when module loads (only in development)
if (process.env.NODE_ENV === "development") {
  console.log("📊 Frontend Daily Limits Configuration:");
  console.log(
    `   POST_PER_USER: ${DAILY_LIMITS_CONFIG.POST_PER_USER}`
  );
  console.log(
    `   AI_IMAGE_PER_USER: ${DAILY_LIMITS_CONFIG.AI_IMAGE_PER_USER}`
  );
  console.log(
    `   AI_IMAGE_GLOBAL: ${DAILY_LIMITS_CONFIG.AI_IMAGE_GLOBAL}`
  );
  console.log(
    `   RESET_TIME: ${String(DAILY_LIMITS_CONFIG.RESET_HOUR).padStart(
      2,
      "0"
    )}:${String(DAILY_LIMITS_CONFIG.RESET_MINUTE).padStart(2, "0")} (UTC+7)`
  );
  console.log(
    `   MAX_AUTO_POST_HOURS: ${DAILY_LIMITS_CONFIG.MAX_AUTO_POST_HOURS}`
  );
}

export default DAILY_LIMITS_CONFIG;

